.editAttributes {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 2rem;
  margin-top: 1rem;
  margin-bottom: 2rem;
}

.button {
  margin-top: 1rem;
}
